import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FAQSchema from "@/components/schema/FAQSchema";
import VPGHeroSection from "@/components/value-proposition-generator/VPGHeroSection";
import VPGWhySection from "@/components/value-proposition-generator/VPGWhySection";
import VPGHowItWorks from "@/components/value-proposition-generator/VPGHowItWorks";
import VPGExamplesSection from "@/components/value-proposition-generator/VPGExamplesSection";
import VPGBenefitsSection from "@/components/value-proposition-generator/VPGBenefitsSection";
import VPGFAQSection from "@/components/value-proposition-generator/VPGFAQSection";
import VPGFinalCTA from "@/components/value-proposition-generator/VPGFinalCTA";
import { faqItems } from "@/components/value-proposition-generator/vpgData";

const ValuePropositionGenerator = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Free Value Proposition Generator | AI Google Ads Copy | Upfixe</title>
        <meta
          name="description"
          content="Generate a custom value proposition for your Google Ads in 30 seconds. Enter your business details and get ad-ready messaging delivered to your inbox. Free tool by Upfixe."
        />
        <meta
          name="keywords"
          content="value proposition generator, ad value proposition tool, google ads value proposition, free value proposition generator, business value proposition creator, value proposition examples, AI ad copy generator, google ads copy tool"
        />
        <meta
          property="og:title"
          content="Free Value Proposition Generator | AI Google Ads Copy | Upfixe"
        />
        <meta
          property="og:description"
          content="Generate a custom value proposition for your Google Ads in 30 seconds. Enter your business details and get ad-ready messaging delivered to your inbox."
        />
        <link rel="canonical" href="https://upfixe.com/value-proposition-generator" />
      </Helmet>
      <FAQSchema items={faqItems} />

      <Header />

      <main className="flex-grow">
        <VPGHeroSection />
        <VPGWhySection />
        <VPGHowItWorks />
        <VPGExamplesSection />
        <VPGBenefitsSection />
        <VPGFAQSection />
        <VPGFinalCTA />
      </main>

      <Footer />
    </div>
  );
};

export default ValuePropositionGenerator;
